import { ServerClient } from 'common/utils/http/http-clients';
import { IIntegrationEvent } from './integration-events.service.types';
import { IResponseList } from 'common/models/response-list.interface';

class IntegrationEventsService {
  async getAll(
    pageLimit: any,
    filter: string | null | undefined,
    sort: string | null | undefined,
  ): Promise<IResponseList<IIntegrationEvent>> {
    const res = await ServerClient.get<IResponseList<IIntegrationEvent>>('integration-events', {
      params: {
        filter,
        ...pageLimit,
        sort,
      },
    });

    return res.data;
  }

  async delete(ids: string[]): Promise<void> {
    await ServerClient.post(`integration-events/delete`, {
      ids,
    });
  }

  async setToRetry(ids: string[]): Promise<void> {
    await ServerClient.post(`integration-events/retry`, {
      ids,
    });
  }
}

export const integrationEventsService = new IntegrationEventsService();
export default integrationEventsService;
